import { render } from "./newsInformation.vue?vue&type=template&id=46bbc512&scoped=true"
import script from "./newsInformation.vue?vue&type=script&lang=js"
export * from "./newsInformation.vue?vue&type=script&lang=js"

import "./newsInformation.vue?vue&type=style&index=0&id=46bbc512&scoped=true&lang=css"
import "./newsInformation.vue?vue&type=style&index=1&id=46bbc512&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46bbc512"]])

export default __exports__